import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  TravelAbroadState,
  clearAddon,
  clearGroupAddon,
  setChooseMethod,
  setCompanyId,
  setLeftCompanyIds,
  setOffer,
} from '../../../store/travelAbroadSlice'
import CompanySelect from '../../../components/v2/CompanySelect'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { AppState } from '../../../store/appSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const ChooseMethod = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const isDataValid = (data: string | any[]) => {
    if (!Array.isArray(data)) {
      return false
    }

    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (
        item.age === null ||
        item.age === 0 ||
        item.date === null ||
        item.date.length !== 14 ||
        Number(item.age) < 0
      ) {
        return false
      }
    }

    return true
  }
  //
  //
  const [getLeftCompanies, { data: leftCompanies, isLoading: isLeftCompanyLoading }] =
    api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.singleOrMulti &&
      filter.travelersDate &&
      filter.travelersDate !== undefined &&
      filter.travelersDate.length >= 1 &&
      isDataValid(filter.travelersDate) &&
      filter.region &&
      filter.currency &&
      ((filter.singleDates?.start && filter.singleDates?.end) ||
        (filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days))
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: 'step-six',
            productCategory: filter.productCategory,
            startDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.start as string)
                : (filter.multiDates?.start as string),
            endDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.end as string)
                : (filter.multiDates?.end as string),
            multiDay: filter.singleOrMulti === 'single-travel' ? null : (filter.multiDays?.days as number),
            travelType: filter.singleOrMulti,
            currency: filter.currency,
            limit: filter.limit as number,
            area: filter.region,
            ages: filter.travelersDate?.map((item) => (item.month === null ? item.age : 0)),
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (ChooseMethod)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleOrMulti,
    filter.multiDates?.start,
    filter.multiDates?.end,
    filter.multiDays?.days,
    filter.region,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.travelersDate,
    getLeftCompanies,
  ])
  //
  const { data: whoWillChooseCompany, isLoading: isWhoWillChooseCompanyLoading } =
    api.useGetWhoWillChooseCompanyQuery(undefined)
  //
  //
  //
  //
  //
  const MainLoading = isLeftCompanyLoading || isWhoWillChooseCompanyLoading
  //
  //
  const SelectedCompanyArray: TravelAbroadState['filter']['selectedCompanies'] = filter.selectedCompanies
  //
  // selected companies
  const matchingObjects = leftCompanies?.filter((obj) => SelectedCompanyArray?.includes(obj.id as never))
  //
  //
  useEffect(() => {
    const LeftCompanyIds = leftCompanies?.map((x) => x.id)
    //
    if (filter.chooseMethod === 'frani-choice' && LeftCompanyIds) {
      dispatch(setLeftCompanyIds(LeftCompanyIds))
    }

    return () => {}
  }, [dispatch, filter.chooseMethod, leftCompanies])

  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('companyChoice')}</title>
        <meta name="description" content={`${t('companyChoice')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('companyChoice')} />

        <AbroadProgressBar stepName={`${t('offerType')}`} />

        <Block>
          {whoWillChooseCompany &&
            whoWillChooseCompany?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  disabled={item.type === 'travel-to-georgia' ? true : false}
                  title={item?.translations?.[lang]?.title}
                  description={item?.translations?.[lang]?.body}
                  imgUrl={item?.image}
                  selected={item.type === filter.chooseMethod ? true : false}
                  onClick={() => [
                    dispatch(setChooseMethod(item.type)),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                    dispatch(setOffer(undefined)),
                  ]}
                >
                  {item.type === filter.chooseMethod && filter.chooseMethod === 'user-choice' ? (
                    <Inner>
                      <hr />
                      <CompanyTitle>{t('chooseInsuranceCompany')}</CompanyTitle>
                      <CompanyDescription>{t('chooseInsuranceCompanyRules')}</CompanyDescription>

                      <CompanySelect
                        closeMenuOnSelect={false}
                        onChange={(data) => dispatch(setCompanyId(data.map((item: any) => item.value)))}
                        isMulti={true}
                        maxSelectLenght={3}
                        maxSelectText={`${t('companyCmpare')}`}
                        placeholder={t('selectCompanies')}
                        showOptionCheckbox={true}
                        value={matchingObjects?.map((s) => ({
                          label: s.brandName?.[lang]?.title,
                          value: s.id,
                          imgUrl: s.logo,
                        }))}
                        options={
                          leftCompanies?.map((item) => ({
                            value: item.id,
                            label: item.brandName?.[lang]?.title,
                            imgUrl: item.logo,
                          })) || []
                        }
                      />
                    </Inner>
                  ) : null}
                </HorizontalCard>
              )
            })}
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/add-travelers')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.chooseMethod &&
              ((filter.chooseMethod === 'frani-choice' && filter.leftCompanyIds && filter.leftCompanyIds.length >= 1) ||
                (filter.chooseMethod === 'user-choice' &&
                  filter.selectedCompanies &&
                  filter.selectedCompanies.length >= 1)) &&
              filter.singleOrMulti &&
              filter.currency &&
              filter.limit &&
              filter.region &&
              filter.travelersDate &&
              filter.travelersDate.find((x) => x.age !== 0) &&
              filter.travelersDate.find((x) => x.date !== null) &&
              ((filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days) ||
                (filter.singleDates?.start && filter.singleDates?.end))
                ? false
                : true
            }
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/travel-offer')
              }
              //
              if (filter.chooseMethod === 'user-choice') {
                navigate('/travel-offers')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const CompanyTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 1px;
`
const CompanyDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const Inner = styled.div`
  /*  */
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default ChooseMethod
